<div class="md-body template-media">
  <div class="container">
    <div class="template_md">

      <!-- Dynamic template name badge -->
      <div class="md-type-badge">{{ templateName }}</div>

      <!-- GALLERY HERO: product images carousel -->
      <header class="md-hero">
        <div class="md-reel">
          <div class="md-default" *ngIf="productImages == null">
            <img src="assets/images/app-devices.jpg" alt="productImage" />
          </div>
          <ngb-carousel *ngIf="productImages && productImages.length > 0" [showNavigationArrows]="true">
            <ng-template ngbSlide *ngFor="let productImage of productImages">
              <div class="md-slide"><img [src]="productImage" alt="productImage" /></div>
            </ng-template>
          </ngb-carousel>
        </div>

        <div class="md-id">
          <div class="md-avatar"><img [src]="imageSrc" alt="profileImage" /></div>
          <div class="md-who">
            <h1>{{ firstName + ' ' + lastName }}</h1>
            <p>{{ jobTitle }}<span *ngIf="companyName"> · {{ companyName }}</span></p>
          </div>
          <div class="md-logo">
            <img *ngIf="logo != null" [src]="imageSrcLogo" alt="logoimage" />
            <img *ngIf="logo == null" src="assets/images/unmasking-yourself.jpg" alt="logoimage" />
          </div>
        </div>
      </header>

      <div class="md-about" *ngIf="content" [innerHTML]="content"></div>

      <div class="md-facts" *ngIf="gpa || school || grade || height || age || weight">
        <span *ngIf="gpa"><b>GPA</b> {{ gpa }}</span>
        <span *ngIf="school"><b>School</b> {{ school }}</span>
        <span *ngIf="grade"><b>Grade</b> {{ grade }}</span>
        <span *ngIf="height"><b>Height</b> {{ height }}</span>
        <span *ngIf="age"><b>Age</b> {{ age }}</span>
        <span *ngIf="weight"><b>Weight</b> {{ weight }}</span>
      </div>

      <!-- VIDEOS: YouTube + Umyotube (YouTube / Dailymotion / umyovideo) + Vimeo -->
      <section class="md-videos">
        <div class="md-sec-title" *ngIf="(youtubeArray && youtubeArray.length > 0 && youtubeArray[0].youtubeLink) || (vimeoArray && vimeoArray.length > 0 && vimeoArray[0].vimeoVideoLink) || (umyotubeArray && umyotubeArray.length > 0 && umyotubeArray[0].umyotubeLink)">
          <i class="fa-solid fa-circle-play"></i> Now Playing
        </div>

        <ng-container *ngFor="let v of youtubeArray">
          <div class="md-video" *ngIf="v.youtubeLink | videoEmbed as src">
            <p class="md-video-title"><i class="fa-brands fa-youtube"></i> {{ v.youtubeTitle }}</p>
            <div class="md-embed">
              <iframe [src]="src" [title]="v.youtubeTitle || 'YouTube player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of umyotubeArray">
          <div class="md-video" *ngIf="v.umyotubeLink | videoEmbed as src">
            <p class="md-video-title"><i class="fa-solid fa-circle-play"></i> {{ v.umyotubeTitle }}</p>
            <div class="md-embed">
              <iframe [src]="src" title="Umyotube player" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of vimeoArray">
          <div class="md-video" *ngIf="v.vimeoVideoLink | videoEmbed as src">
            <p class="md-video-title"><i class="fa-brands fa-vimeo-v"></i> {{ v.vimeoVideoTitle }}</p>
            <div class="md-embed">
              <iframe [src]="src" [title]="v.vimeoVideoTitle || 'Vimeo player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>
      </section>

      <!-- Playlist links -->
      <section class="md-playlist" *ngIf="buttons && buttons.length > 0 && buttons[0].LinkButtonTitle">
        <div class="md-h"><i class="fa-solid fa-list-ul"></i> Playlist</div>
        <ng-container *ngFor="let button of buttons; let i = index">
          <a class="md-track" *ngIf="button" [href]="button.LinkButtonLink" target="_blank">
            <span class="md-no">{{ i + 1 | number : '2.0-0' }}</span>
            <span class="md-track-txt">
              <b>{{ button.LinkButtonTitle }}</b>
              <small>{{ firstName }} {{ lastName }}</small>
            </span>
            <span class="md-play" [style.background-color]="buttonColor || null"><i class="fa-solid fa-play"></i></span>
          </a>
        </ng-container>
      </section>

      <section class="md-social" *ngIf="instagram || youtube || facebook || twitter || linkedin || pinterest">
        <a [href]="instagram" target="_blank" *ngIf="instagram" class="md-s-instagram"><i class="fa-brands fa-instagram"></i><span>Instagram</span></a>
        <a [href]="youtube" target="_blank" *ngIf="youtube" class="md-s-youtube"><i class="fa-brands fa-youtube"></i><span>YouTube</span></a>
        <a [href]="facebook" target="_blank" *ngIf="facebook" class="md-s-facebook"><i class="fa-brands fa-facebook-f"></i><span>Facebook</span></a>
        <a [href]="twitter" target="_blank" *ngIf="twitter" class="md-s-twitter"><i class="fa-brands fa-twitter"></i><span>Twitter</span></a>
        <a [href]="linkedin" target="_blank" *ngIf="linkedin" class="md-s-linkedin"><i class="fa-brands fa-linkedin-in"></i><span>LinkedIn</span></a>
        <a [href]="pinterest" target="_blank" *ngIf="pinterest" class="md-s-pinterest"><i class="fa-brands fa-pinterest-p"></i><span>Pinterest</span></a>
      </section>

      <section class="md-contact">
        <a [href]="'tel:' + phone" class="md-c-tel"><i class="fa-solid fa-phone"></i></a>
        <a [href]="'sms:' + phone" *ngIf="phoneAllow" class="md-c-sms"><i class="fa-solid fa-comments"></i></a>
        <a [href]="'mailto:' + email" class="md-c-mail"><i class="fa-solid fa-envelope"></i></a>
        <a [href]="'https://www.google.com/maps?q=' + address" target="_blank" class="md-c-map" *ngIf="address"><i class="fa-solid fa-location-dot"></i></a>
      </section>

      <div class="md-ctrls">
        <button type="button" class="ctrl-item" *ngIf="forwardCard" data-bs-toggle="modal" data-bs-target="#shareCard">
          <i class="fa-solid fa-share"></i><h3>Forward</h3>
        </button>
        <a (click)="navigateToHome()" type="button" class="ctrl-item">
          <i class="fa-solid fa-right-to-bracket"></i><h3>Sign Up</h3>
        </a>
        <button type="button" class="ctrl-item" *ngIf="saveCard" (click)="downloadVCard()">
          <i class="fa-solid fa-download"></i><h3>Save My Card</h3>
        </button>
      </div>

      <footer class="md-footer">
        <img class="md-qr" *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" />
        <p class="md-strip">Watch <i></i> Listen <i></i> Share</p>
        <p class="md-powered">This card is powered by <span>UMYO Cards</span></p>
        <form action="" class="referal-form" *ngIf="inviteCode">
          <label for="referal">Referral ID: </label>
          <input type="text" name="referal" id="referal" [value]="referal" disabled placeholder="XXXXX" />
        </form>
        <a [routerLink]="['/']" class="call-to-action">
          <span class="left">Click<br />Here</span>
          <span class="right">Design your card now!</span>
        </a>
      </footer>

    </div>
  </div>
</div>